import axios from 'axios';

import { VatCategory } from './types';

export const vatCategoriesApi = axios.create({
  baseURL: process.env.VAT_CATEGORIES_URI,
});

export default vatCategoriesApi;

export const getVatCategories = async (country: string) =>
  vatCategoriesApi
    .get<VatCategory[]>(`/v1/vat-categories/active/${country}?visibility=MENU_EDITOR`)
    .then(res => res.data);
